import { ABSOLUTE_DATE_TIME_FORMAT, KST } from 'constants/time';
import { DateTime } from 'luxon';
export const DEFAULT_APP_ZONE = KST;
export const DEFAULT_APP_LOCALE = 'ko';
export function nowInAppZone(zoneOverride, locale) {
  return DateTime.now().setZone(zoneOverride || DEFAULT_APP_ZONE).setLocale(locale || DEFAULT_APP_LOCALE);
}
export function fromJsDateInAppZone(jsDate, zoneOverride, locale) {
  return DateTime.fromJSDate(jsDate, {
    zone: zoneOverride || DEFAULT_APP_ZONE,
    locale: locale || DEFAULT_APP_LOCALE
  });
}
export function fromISOInAppZone(isoString, zoneOverride, locale) {
  return DateTime.fromISO(isoString, {
    zone: zoneOverride || DEFAULT_APP_ZONE,
    locale: locale || DEFAULT_APP_LOCALE
  });
}
export function toAppZone(dateTime, zoneOverride, locale) {
  return dateTime.setZone(zoneOverride || DEFAULT_APP_ZONE).setLocale(locale || DEFAULT_APP_LOCALE);
}
export function fromObjectToDateTimeInAppZone(object, zoneOverride, locale) {
  return DateTime.fromObject(object, {
    zone: zoneOverride || DEFAULT_APP_ZONE,
    locale: locale || DEFAULT_APP_LOCALE
  });
}
export function formatDateToYYYYMMDD(date) {
  if (!date) return '';
  if (date instanceof Date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
  return date.toFormat('yyyy-MM-dd');
}
export const getRelativeDateTimeText = dateTime => {
  const now = DateTime.now();
  const diffInSeconds = Math.abs(now.diff(dateTime, 'seconds').seconds);
  const diffInMinutes = Math.abs(now.diff(dateTime, 'minutes').minutes);
  const diffInHours = Math.abs(now.diff(dateTime, 'hours').hours);
  const diffInDays = Math.abs(now.diff(dateTime, 'days').days);
  const diffInMonths = Math.abs(now.diff(dateTime, 'months').months);
  const diffInYears = Math.abs(now.diff(dateTime, 'years').years);

  // 60초 미만
  if (diffInSeconds < 60) {
    return '방금';
  }

  // 1분 이상 ~ 60분 미만
  if (diffInMinutes < 60) {
    return `${Math.floor(diffInMinutes)}분 전`;
  }

  // 1시간 이상 ~ 24시간 미만
  if (diffInHours < 24) {
    return `${Math.floor(diffInHours)}시간 전`;
  }

  // 1일 이상 ~ 31일 미만
  if (diffInDays < 31) {
    return `${Math.floor(diffInDays)}일 전`;
  }

  // 31일 이상 ~ 12개월 미만
  if (diffInMonths < 12) {
    return `${Math.floor(diffInMonths)}달 전`;
  }

  // 12개월 이상
  return `${Math.floor(diffInYears)}년 전`;
};
export const getAbsoluteDateTimeText = (dateTime, timezone = DEFAULT_APP_ZONE, locale = DEFAULT_APP_LOCALE) => {
  return dateTime.setZone(timezone).toFormat(ABSOLUTE_DATE_TIME_FORMAT, {
    locale
  });
};